import { apiPaths } from '../config/api-paths.js';
import request from '../utils/request.js';
import type { ApiResponse, RequestResult, School } from '../types/domain.js';

export async function getThroughSchoolList(): Promise<RequestResult<ApiResponse<School[]>>> {
  return request<ApiResponse<School[]>>(apiPaths.throughSchoolList);
}
